// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 2462 ? "react-monaco-editor" : chunkId) + "." + {"2462":"ae6d46e7","2706":"27a3b0a1","4924":"3e56ab62"}[chunkId] + ".chunk.css";
};